import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ContactDetail_create, ContactDetail_delete, ContactDetail_readAll, ContactDetail_readById, ContactDetail_readByMasterId, ContactDetail_update } from "src/app/GlobalVariables";
import { ContactDetailCreateRequestDTO, ContactDetailDeleteRequestDTO, ContactDetailDTO, ContactDetailList, ContactDetailReadByIdRequestDTO, ContactDetailReadByMasterIdRequestDTO, ContactDetailUpdateRequestDTO } from "./contact-detail.interface";

@Injectable({
    providedIn: 'root'
})
export class ContactDetailService {
    constructor() { }

    http = inject(HttpClient)



    ContactDetail_create(data: ContactDetailCreateRequestDTO): Observable<ContactDetailDTO> {
        return this.http.post<ContactDetailDTO>(ContactDetail_create, data)
    }
    ContactDetail_update(data: ContactDetailUpdateRequestDTO): Observable<ContactDetailDTO> {
        return this.http.post<ContactDetailDTO>(ContactDetail_update, data)
    }
    ContactDetail_readById(data: ContactDetailReadByIdRequestDTO): Observable<ContactDetailDTO> {
        return this.http.post<ContactDetailDTO>(ContactDetail_readById, data)
    }
    ContactDetail_readAll(): Observable<ContactDetailList> {
        return this.http.get<ContactDetailList>(ContactDetail_readAll)
    }
    ContactDetail_readByMasterId(data: ContactDetailReadByMasterIdRequestDTO): Observable<ContactDetailList> {
        return this.http.post<ContactDetailList>(ContactDetail_readByMasterId, data)
    }
    ContactDetail_delete(data: ContactDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(ContactDetail_delete, data)
    }
}